import { render, staticRenderFns } from "./Pamphlet.vue?vue&type=template&id=1c062f5e&scoped=true&"
import script from "./Pamphlet.vue?vue&type=script&lang=js&"
export * from "./Pamphlet.vue?vue&type=script&lang=js&"
import style0 from "./Pamphlet.vue?vue&type=style&index=0&id=1c062f5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c062f5e",
  null
  
)

export default component.exports